import React from "react"
import { LanguageProvider, TranslationsProvider } from "globant";

export const wrapPageElement = ({ element, props }) => {
  return /*#__PURE__*/React.createElement(TranslationsProvider, {
    translations: props.pageContext.translations
  }, element);
}

export const wrapRootElement = ({ element }) => {
  return (<LanguageProvider>{element}</LanguageProvider>)
}